export default {
    'delete-message': 'Are you sure you want to delete this task type?'
}